import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-4 max-w-3xl mx-auto" data-id="element-172">
      <FadeIn data-id="element-173">
        <div className="bg-gradient-to-br from-green-900/20 to-gray-900 border border-green-500/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-174">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-175"></div>

          <ShieldCheck className="w-20 h-20 text-green-500 mx-auto mb-6" data-id="element-176" />

          <h2 className="text-3xl md:text-4xl font-black mb-8 text-white" data-id="element-177">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-gray-300 font-medium max-w-xl mx-auto" data-id="element-178">
            <p data-id="element-179">Abrís los tomos. Los usás en tus campañas.</p>
            <p data-id="element-180">Si en 7 días no es lo que esperabas:</p>
            <p className="text-green-400 font-bold text-2xl py-2" data-id="element-181">
              → Devolución del 100%. Sin formularios, sin drama.
            </p>
            <p className="text-sm text-gray-500 mt-6 pt-6 border-t border-gray-800" data-id="element-182">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}